<template>
  <svg
    class="icon-close"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="32"
    width="32"
  >
    <line x1="23" y1="9" x2="9" y2="23" />
    <line x1="9" y1="9" x2="23" y2="23" />
  </svg>
</template>

<script>
export default {
  name: "IconClose"
};
</script>
